import { useLocation, Outlet } from 'react-router-dom';
import { AppRoutes } from '../../../enums/Approutes';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';

const Layout = () => {
    const location = useLocation();
    const hideFooter =
        location.pathname === AppRoutes.CHAT
        || location.pathname === AppRoutes.REFERRAL
        || location.pathname === AppRoutes.BILLING
        || location.pathname === AppRoutes.BILLING_SUCCESS
        || location.pathname === AppRoutes.BILLING_CANCELED;

    return (
        <>
            <Navbar />
            <Outlet />
            {!hideFooter && <Footer />}
        </>
    );
};

export default Layout;
